import * as React from "react";

const SvgIcnSpeechSearches = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M14 9a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 9zm0 1a3 3 0 100 6 3 3 0 000-6zm-.377-5C14.383 5 15 5.619 15 6.382l.001 1.718a5.003 5.003 0 00-.689-.09V6.382a.69.69 0 00-.69-.691H5.378a.69.69 0 00-.688.691v8.927l2.148-2.035h2.17c.013.235.042.466.086.691H7.111l-1.95 1.847A.687.687 0 014 15.309V6.382A1.38 1.38 0 015.377 5h8.246zM6.5 11h2.916a4.962 4.962 0 00-.316 1H6.5a.5.5 0 010-1h2.916zm0-2H11a5.03 5.03 0 00-1 1H6.5a.5.5 0 010-1H11zm6-2a.5.5 0 010 1h-6a.5.5 0 010-1h6z"
        />
    </svg>
);

export default SvgIcnSpeechSearches;
